
<template>
  <div>
    <Header />
    <v-container>
      <v-row justify="center" align="center" fill-height>
        <v-col cols="12" xl="8">
          <v-card :loading="loading">
            <v-container>
              <v-card-title>Apps</v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <p>Wählen Sie eine App aus oder erstellen Sie eine neue.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <AddNewApp></AddNewApp>
                  </v-row>
                  <v-row>
                    <AppListItem
                      v-for="item in list"
                      v-bind:key="item.id"
                      v-bind:id="item.id"
                      v-bind:name="item.name"
                      v-bind:url="item.url"
                      v-bind:src="'http://acs.accelery.de/api/assets/'+ item.assetId"
                      v-bind:color1="item.color1"
                      v-bind:color2="item.color2"
                      v-bind:apiKey="item.apiKey"
                    ></AppListItem>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="12" xl="8">
          <v-card>
            <v-card-title>Assets</v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-btn @click="openFonts">Schriftarten verwalten</v-btn>
                    <v-btn @click="openOptions">Optionen verwalten</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AppService from "@/services/AppService";
import Header from "@/views/general/header";
import router from "@/plugins/router";
import AppListItem from "@/views/apps/components/AppListItem";
import AddNewApp from "@/views/apps/components/AddNewApp";

export default {
  name: "dashboard",
  components: {
    Header: Header,
    AppListItem: AppListItem,
    AddNewApp: AddNewApp
  },
  data: () => ({
    loading: true,
    list: [
     
    ]
  }),
  mounted() {
    this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      try {
        let data = (await AppService.get()).data;
        if (data) {
          this.list = data;
        } else {
          this.list = [];
        }
        this.loading = false;
      } catch (err) {
        if (err.response.status == 401) {
          router.replace("/auth/login");
        }
      }
    },
    openFonts() {
      router.push({ name: "Fonts" });
    },
    openOptions() {
      router.push({ name: "Options" });
    },
  }
};
</script>

